<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  mounted() {
    var curImg    = new Image();
    curImg.src    = require("@/assets/faydark.png");
    curImg.onload = function () {
      // do whatever here, add it to the background, append the image ect.
      document.body.style.setProperty("--image", "url(" + curImg.src + ")");
    }
  }
}
</script>

<style lang="scss">

body {
  /* background-repeat: no-repeat; */
  background:            -webkit-radial-gradient(circle, transparent 40%, var(--color-v) 95%), linear-gradient(to right, var(--color), var(--color)), var(--image) !important;
  background:            radial-gradient(circle, transparent 40%, var(--color-v) 95%), linear-gradient(to right, var(--color), var(--color)), var(--image);

  /*background-position:   center center;*/
  background-size:       cover;
  /*background-repeat:     no-repeat;*/

  background-repeat:repeat-x;
  background-attachment:fixed;
  background-position: left top;

  /*background-attachment: fixed;*/
  background-blend-mode: normal, saturation, normal;
  /*--image:               url(~@/assets/img/eq-wallpaper-1.jpg);*/
  --color-v:             black;
  --color:               grey;
}

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar:horizontal {
  height: 6px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

html {
  background-color: black;
}
</style>
